export default __webpack_public_path__ + "static/blog1-97584da45d1cd9a8bfa5c709eb16fc1b.jpeg";